module.exports = __webpack_public_path__ + "static/media/logo.231154a1.png";